// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yc-select-item-wrap {
  position: relative;
  margin-top: 4px;
  overflow-y: hidden;
}
.yc-select-item-wrap:last-child {
  margin-bottom: 4px;
  overflow: hidden;
}
.yc-select_mobile .yc-select-item-wrap {
  overflow-x: hidden;
}

.yc-select-item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 12px 0 16px;
  font-size: 13px;
  line-height: 28px;
  min-height: 28px;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  z-index: 1;
  box-sizing: border-box;
}
.yc-select_mobile .yc-select-item {
  line-height: 40px;
  font-size: 15px;
}
.yc-select_desktop .yc-select-item_multiple {
  padding-right: 26px;
}
.yc-select_desktop .yc-select-item:hover .yc-select-item__ext-link {
  display: flex;
}
.yc-select_desktop .yc-select-item:not(.yc-select-item_selected):hover, .yc-select_desktop .yc-select-item_multiple:hover {
  background-color: var(--g-color-base-simple-hover);
}
.yc-select_desktop .yc-select-item:hover .yc-select-item__only-btn {
  display: block;
}
.yc-select-item_show-meta {
  line-height: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.yc-select_mobile .yc-select-item_show-meta {
  line-height: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.yc-select-item_with-transition {
  transition: left 100ms ease;
}
.yc-select-item_selected:not(.yc-select-item_multiple) {
  background-color: var(--g-color-base-selection);
}
.yc-select-item_disabled {
  color: var(--g-color-text-secondary);
  pointer-events: none;
}
.yc-select-item__tick-wrap {
  /* stylelint-disable */
  width: 16px !important;
  height: 16px !important;
}
.yc-select_desktop .yc-select-item__tick-wrap {
  position: absolute;
  top: 50%;
  right: 10px !important;
  transform: translateY(-50%);
}
.yc-select_mobile .yc-select-item__tick-wrap {
  width: 14px;
  height: 14px;
}
.yc-select_desktop .yc-select-item__ext-link {
  margin-right: 8px;
}
.yc-select-item__tick {
  color: var(--g-color-base-brand);
}
.yc-select-item__icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.yc-select-item__icon_small {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
.yc-select-item__icon_large {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.yc-select-item__info {
  flex: 1 1 auto;
  overflow: hidden;
}
.yc-select-item__title, .yc-select-item__meta {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.yc-select-item__title_secondary {
  font-style: italic;
  opacity: 0.5;
}
.yc-select-item__meta {
  color: var(--g-color-text-secondary);
}
.yc-select-item__only-btn {
  display: none;
}
.yc-select-item__only-btn_mobile {
  position: absolute;
  top: 0;
  right: -80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  font-size: 15px;
  color: var(--g-color-text-light-primary);
  background-color: var(--g-color-base-brand);
}
.yc-select-item__only-btn_with-transition {
  transition: right 100ms ease;
}
.yc-select-item__ext-link {
  display: none;
}
.yc-select-item__ext-link_mobile {
  position: absolute;
  top: 0;
  right: -80px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  font-size: 15px;
  color: var(--g-color-text-light-primary);
  background-color: var(--g-color-base-positive-heavy);
}
.yc-select-item__ext-link_with-transition {
  transition: right 100ms ease;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/YCSelect/Item/Item.scss"],"names":[],"mappings":"AAgBA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;AAfJ;AAiBI;EACI,kBAAA;EACA,gBAAA;AAfR;AAkBI;EACI,kBAAA;AAhBR;;AAoBA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;AAjBJ;AAmBI;EACI,iBAAA;EACA,eAAA;AAjBR;AAoBI;EACI,mBAAA;AAlBR;AAqBI;EACI,aAAA;AAnBR;AAsBI;EAEI,kDAAA;AArBR;AAwBI;EACI,cAAA;AAtBR;AAyBI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAvBR;AAyBQ;EACI,iBAAA;EACA,iBAAA;EACA,oBAAA;AAvBZ;AA2BI;EACI,2BAAA;AAzBR;AA4BI;EACI,+CAAA;AA1BR;AA6BI;EACI,oCAAA;EACA,oBAAA;AA3BR;AA8BI;EACI,sBAAA;EACA,sBAAA;EACA,uBAAA;AA5BR;AA8BQ;EACI,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;AA5BZ;AA+BQ;EACI,WAAA;EACA,YAAA;AA7BZ;AAiCI;EACI,iBAAA;AA/BR;AAkCI;EACI,gCAAA;AAhCR;AAmCI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjCR;AAmCQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAjCZ;AAoCQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAlCZ;AAsCI;EACI,cAAA;EACA,gBAAA;AApCR;AAuCI;EAEI,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtCR;AA0CQ;EACI,kBAAA;EACA,YAAA;AAxCZ;AA4CI;EACI,oCAAA;AA1CR;AA6CI;EACI,aAAA;AA3CR;AA6CQ;EA7JJ,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,2CAqJ+B;AAlCnC;AAqCQ;EACI,4BAAA;AAnCZ;AAuCI;EACI,aAAA;AArCR;AAuCQ;EAzKJ,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,oDAiK+B;AA5BnC;AA+BQ;EACI,4BAAA;AA7BZ","sourcesContent":[".yc-select-item-wrap {\n  position: relative;\n  margin-top: 4px;\n  overflow-y: hidden;\n}\n.yc-select-item-wrap:last-child {\n  margin-bottom: 4px;\n  overflow: hidden;\n}\n.yc-select_mobile .yc-select-item-wrap {\n  overflow-x: hidden;\n}\n\n.yc-select-item {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 0 12px 0 16px;\n  font-size: 13px;\n  line-height: 28px;\n  min-height: 28px;\n  user-select: none;\n  cursor: pointer;\n  z-index: 1;\n  box-sizing: border-box;\n}\n.yc-select_mobile .yc-select-item {\n  line-height: 40px;\n  font-size: 15px;\n}\n.yc-select_desktop .yc-select-item_multiple {\n  padding-right: 26px;\n}\n.yc-select_desktop .yc-select-item:hover .yc-select-item__ext-link {\n  display: flex;\n}\n.yc-select_desktop .yc-select-item:not(.yc-select-item_selected):hover, .yc-select_desktop .yc-select-item_multiple:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.yc-select_desktop .yc-select-item:hover .yc-select-item__only-btn {\n  display: block;\n}\n.yc-select-item_show-meta {\n  line-height: 16px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.yc-select_mobile .yc-select-item_show-meta {\n  line-height: 20px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.yc-select-item_with-transition {\n  transition: left 100ms ease;\n}\n.yc-select-item_selected:not(.yc-select-item_multiple) {\n  background-color: var(--g-color-base-selection);\n}\n.yc-select-item_disabled {\n  color: var(--g-color-text-secondary);\n  pointer-events: none;\n}\n.yc-select-item__tick-wrap {\n  /* stylelint-disable */\n  width: 16px !important;\n  height: 16px !important;\n}\n.yc-select_desktop .yc-select-item__tick-wrap {\n  position: absolute;\n  top: 50%;\n  right: 10px !important;\n  transform: translateY(-50%);\n}\n.yc-select_mobile .yc-select-item__tick-wrap {\n  width: 14px;\n  height: 14px;\n}\n.yc-select_desktop .yc-select-item__ext-link {\n  margin-right: 8px;\n}\n.yc-select-item__tick {\n  color: var(--g-color-base-brand);\n}\n.yc-select-item__icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.yc-select-item__icon_small {\n  width: 16px;\n  height: 16px;\n  margin-right: 6px;\n}\n.yc-select-item__icon_large {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n.yc-select-item__info {\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n.yc-select-item__title, .yc-select-item__meta {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.yc-select-item__title_secondary {\n  font-style: italic;\n  opacity: 0.5;\n}\n.yc-select-item__meta {\n  color: var(--g-color-text-secondary);\n}\n.yc-select-item__only-btn {\n  display: none;\n}\n.yc-select-item__only-btn_mobile {\n  position: absolute;\n  top: 0;\n  right: -80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  font-size: 15px;\n  color: var(--g-color-text-light-primary);\n  background-color: var(--g-color-base-brand);\n}\n.yc-select-item__only-btn_with-transition {\n  transition: right 100ms ease;\n}\n.yc-select-item__ext-link {\n  display: none;\n}\n.yc-select-item__ext-link_mobile {\n  position: absolute;\n  top: 0;\n  right: -80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  font-size: 15px;\n  color: var(--g-color-text-light-primary);\n  background-color: var(--g-color-base-positive-heavy);\n}\n.yc-select-item__ext-link_with-transition {\n  transition: right 100ms ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
